<template>
	<div>
		<Breadcrumb :list="breadcrumbList"></Breadcrumb>
		<el-card class="main">
			<el-row type="flex" class="subject_title">
				<img src="@/assets/img/tag.png" alt="">
				<span class="title_a">可疑情况</span>
			</el-row>
			<el-form ref="form" :model="form" :rules="rules" label-width="auto" class="form">
				<!-- 一 -->
				<el-row>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="可疑类型" prop="kyqklxdm">
							<el-select v-model="form.kyqklxdm" placeholder="请选择" style="width:100%">
								<el-option v-for="item in kylxList" :key="item.code" :label="item.title" :value="item.code">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="填报人姓名" prop="djrxm">
							<el-input v-model="form.djrxm" size="large"></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 7, offset: 1 }" :xl="7">
						<el-form-item label="填报人电话" prop="djrdh">
							<el-input v-model="form.djrdh" size="large"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 二 -->
				<el-row>

				</el-row>
				<!-- 三 -->
				<el-row>
					<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 15, offset: 1 }" :xl="15">
						<el-form-item label="疑点描述" prop="kyqk_jyms">
							<el-input v-model="form.kyqk_jyms" size="large" type="textarea" :autosize="{ minRows: 1, maxRows: 4 }">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>

			<div style="text-align:center; margin-top: 51px;">
				<el-button type="info" @click="$router.back(-1)">返回</el-button>
				<el-button class="change" type="primary" @click="isOk">确定</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { getkyqkitem, addKyqkItem, saveKyqkItem } from '@/api/day_work'
import { lists } from '@/utils/dictionary.js'
import { regular } from '@/utils/validate'
export default {
	name: "AddSuspiciousVue",
	data() {
		return {
			breadcrumbList: [
				{ name: "可疑情况", path: "suspicious" },
				{ name: "新增", path: "suspicious/add_suspicious" }
			],
			reviseId: null,
			kylxList: [],
			form: {},
			rules: {
				kyqklxdm: [
					{ required: true, message: '请选择可疑类型', trigger: 'change' },
				],
				djrxm: [
					{ required: true, message: '请输入填报人姓名', trigger: 'blur' },
				],
				djrdh: [
					{ required: true, message: '请输入填报人电话', trigger: 'blur' },
					{
						pattern: regular.phone,
						message: '请输入正确的手机号码',
						trigger: 'blur'
					}
				],
				kyqk_jyms: [
					{ required: true, message: '请输入疑点描述', trigger: 'blur' },
				],
			},
			cache: 0 // 0返回 1确认
		};
	},
	created() {
		this.reviseId = this.$route.query.id

	},
	mounted() {
		this.info()
	},
	methods: {
		async info() {
			const id = this.reviseId
			// 获取字典
			this.kylxList = lists['KYLX']
			// 如果路由传参 id , 那么是编辑页面 , 无 则是新增页面
			if (id) {
				// 修改
				this.breadcrumbList[1].name = '修改'
				// 回填
				const res = await getkyqkitem(id)
				this.form = res
				// 回填处理

			} else {
				// 新增
				this.breadcrumbList[1].name = '新增'

			}
		},
		isOk() {
			// 点击确认 
			this.cache = 1


			this.form = {
				kyqklxdm: this.form.kyqklxdm,
				djrxm: this.form.djrxm,
				djrdh: this.form.djrdh,
				kyqk_jyms: this.form.kyqk_jyms,
			}
			this.$refs['form'].validate(async (valid) => {
				if (valid) {
					this.loading = true

					const data = this.reviseId ? { ...this.form, id: this.reviseId } : { ...this.form }
					if (this.reviseId) {
						await saveKyqkItem(data)
						this.$message({
							showClose: true,
							message: '修改成功',
							type: 'success'
						})
					} else {
						await addKyqkItem(data)
						this.$message({
							showClose: true,
							message: '新增成功',
							type: 'success'
						})
					}
					this.$router.push('/suspicious')
				} else {
					console.log('error submit!!')
					return false
				}
			})
		}
	},
	watch: {
		cache(val) {
			// 点击确认,清除缓存
			if (val === 1) {
				this.$store.commit('setKeep', '')
			}
		}
	},
	components: { Breadcrumb }
}
</script>

<style lang="less" scoped>
</style>